/** CCTV rotate_180 표시용 — CSS만 사용(재인코딩 없음) */

import type { ZoneRect } from './cctvZoneView';
import { normalizeZoneRect } from './cctvZoneView';

export function cctvDisplayRotateSx(rotate180: boolean | undefined | null) {
  return rotate180 ? ({ transform: 'rotate(180deg)' } as const) : undefined;
}

export function isCctvRotate180(
  cctv: { rotate_180?: boolean } | null | undefined
): boolean {
  return Boolean(cctv?.rotate_180);
}

/** 180도 회전 후 점 (프레임/크롭 좌표계). 두 번 적용하면 원위치. */
export function remapPointRotate180(
  x: number,
  y: number,
  frameW: number,
  frameH: number
): { x: number; y: number } {
  const fw = Math.max(1, frameW);
  const fh = Math.max(1, frameH);
  return { x: fw - Number(x), y: fh - Number(y) };
}

/** bbox [x1,y1,x2,y2] → 180도 회전 표시 좌표 */
export function remapBboxRotate180(
  bbox: number[],
  frameW: number,
  frameH: number
): ZoneRect {
  const x1 = Number(bbox[0]);
  const y1 = Number(bbox[1]);
  const x2 = Number(bbox[2]);
  const y2 = Number(bbox[3]);
  const a = remapPointRotate180(x1, y1, frameW, frameH);
  const b = remapPointRotate180(x2, y2, frameW, frameH);
  return normalizeZoneRect(a.x, a.y, b.x, b.y);
}

/** risk/special zone 사각형 목록 180 회전 */
export function remapZoneListRotate180(
  zones: number[][] | null | undefined,
  frameW: number,
  frameH: number
): number[][] | undefined {
  if (!Array.isArray(zones) || zones.length === 0) return undefined;
  const out: number[][] = [];
  for (const z of zones) {
    if (!Array.isArray(z) || z.length < 4) continue;
    out.push(remapBboxRotate180(z, frameW, frameH));
  }
  return out.length ? out : undefined;
}
